import React from "react";
import Header from "../../Components/Header";
import AdminDashboard from "../../TeleComponent/AdminDashboard";
import RejectionDashboard from "../../TeleComponent/RejectionDashboard";
import DeleteDashboard from "../../TeleComponent/DeleteDashboard";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import Admin from "./SocialMediaBrokerage";
import PersonalisedLink from "./ApprovedBrokerage";
import GeneralLink from "./PendingBrokerage";
import SocialMediaBrokerage from "./SocialMediaBrokerage";
import ApprovedBrokerage from "./ApprovedBrokerage";
import PendingBrokerage from "./PendingBrokerage";
import RejectedBrokerage from "./RejectedBrokerage";
function SocialMediaBrokerageTabs(props) {
    return (
        <div>
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <div className="tab-content card-box" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="admin-tab"
                                            data-toggle="tab"
                                            data-target="#admin"
                                            type="button"
                                            role="tab"
                                            aria-controls="admin"
                                            aria-selected="true"
                                        >
                                            Social Media Brokerage
                                        </button>
                                    </li>
                                    {/* <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="rejection-tab"
                                            data-toggle="tab"
                                            data-target="#rejection"
                                            type="button"
                                            role="tab"
                                            aria-controls="rejection"
                                            aria-selected="false"
                                        >
                                           Approved
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="pending-tab"
                                            data-toggle="tab"
                                            data-target="#pending"
                                            type="button"
                                            role="tab"
                                            aria-controls="pending"
                                            aria-selected="false"
                                        >
                                            Pending
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="deletedash-tab"
                                            data-toggle="tab"
                                            data-target="#deletedash"
                                            type="button"
                                            role="tab"
                                            aria-controls="deletedash-tab"
                                            aria-selected="false"
                                        >
                                            Rejected
                                        </button>
                                    </li> */}
                                </ul>
                            </div>
                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                    <div
                                        className="tab-pane fade show active"
                                        id="admin"
                                        role="tabpanel"
                                        aria-labelledby="nav-admin-tab"
                                    >
                                        <SocialMediaBrokerage/>
                                    </div>

                                    <div
                                        className="tab-pane fade show "
                                        id="rejection"
                                        role="tabpanel"
                                        aria-labelledby="nav-rejection-tab"
                                    >
                                        <ApprovedBrokerage />
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="pending"
                                        role="tabpanel"
                                        aria-labelledby="nav-pending-tab"
                                    >
                                        <PendingBrokerage />
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="deletedash"
                                        role="tabpanel"
                                        aria-labelledby="nav-deletedash-tab"
                                    >
                                        <RejectedBrokerage />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default SocialMediaBrokerageTabs;
